export interface ParsedNotes {
  founder: {
    name: string;
    twitter: string | null;
    tier: number | null;
    tierReason: string | null;
    bullets: string[];
  } | null;
  backerText: string | null;
  failedProviders: string[];
  remainingNotes: string[];
}

export function parseNotesField(notes: string | null): ParsedNotes {
  const result: ParsedNotes = {
    founder: null,
    backerText: null,
    failedProviders: [],
    remainingNotes: [],
  };
  if (!notes) return result;

  const segments = notes.split(/\s*\|\s*/);

  for (const seg of segments) {
    const trimmed = seg.trim();
    if (!trimmed) continue;

    const failedMatch = trimmed.match(/^Failed(?:\s*providers)?:\s*(.+)/i);
    if (failedMatch) {
      const providerText = failedMatch[1] ?? "";
      result.failedProviders.push(
        ...providerText
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      );
      continue;
    }

    const backerMatch = trimmed.match(/^(?:Manual\s+)?[Bb]ackers?:\s*(.+)/);
    if (backerMatch) {
      const backerText = (backerMatch[1] ?? "").trim();
      result.backerText = backerText.length > 0 ? backerText : null;
      continue;
    }

    if (/^Backer issue:/i.test(trimmed)) continue;
    if (/^Founder Twitter not found/i.test(trimmed)) continue;
    if (/^Founder issue:/i.test(trimmed)) continue;
    if (/^Suggested founder:/i.test(trimmed)) continue;

    const founderMatch = trimmed.match(/^Founder:\s*(.+)/);
    if (founderMatch) {
      const lines = trimmed.split("\n");
      const name = (founderMatch[1] ?? "").trim();
      let twitter: string | null = null;
      let tier: number | null = null;
      let tierReason: string | null = null;
      const bullets: string[] = [];

      for (const line of lines.slice(1)) {
        const t = line.trim();
        const twMatch = t.match(/^Twitter:\s*@?(\S+)/i);
        if (twMatch) {
          const twitterHandle = twMatch[1] ?? "";
          twitter = twitterHandle === "not" ? null : twitterHandle || null;
          continue;
        }
        const tierMatch = t.match(/^Tier\s+(\d):\s*(.*)/);
        if (tierMatch) {
          tier = Number(tierMatch[1] ?? 0);
          tierReason = tierMatch[2] ?? null;
          continue;
        }
        if (t.startsWith("•")) {
          bullets.push(t.replace(/^•\s*/, ""));
        }
      }
      result.founder = { name, twitter, tier, tierReason, bullets };
      continue;
    }

    // Legacy: skip score breakdown lines from old audit runs still in DB
    if (
      /^(Social|Backers|Pedigree|Dev|Momentum|Revenue|Total|Confidence):\s*[+-]?[\d.]+/.test(
        trimmed
      )
    )
      continue;

    if (/^DefiLlama:\s*\S+$/.test(trimmed)) continue;

    result.remainingNotes.push(trimmed);
  }

  return result;
}
